import React from "react";

import WhyUsPage from "../routes/why-us";

const WhyUsTemplate = (props) => <WhyUsPage {...props} />;

export default WhyUsTemplate;
